var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 3H21.667C21.9322 3 22.1866 3.10536 22.3741 3.29289C22.5616 3.48043 22.667 3.73478 22.667 4V20C22.667 20.2652 22.5616 20.5196 22.3741 20.7071C22.1866 20.8946 21.9322 21 21.667 21H3.66699C3.40178 21 3.14742 20.8946 2.95989 20.7071C2.77235 20.5196 2.66699 20.2652 2.66699 20V4C2.66699 3.73478 2.77235 3.48043 2.95989 3.29289C3.14742 3.10536 3.40178 3 3.66699 3V3ZM20.667 7.238L12.739 14.338L4.66699 7.216V19H20.667V7.238ZM5.17799 5L12.728 11.662L20.169 5H5.17799Z",
    fill: "#BDBDBD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/Icon_Mail.b4fb229bd1d24f6e2968f86adbaa0e1a.svg";
export { ForwardRef as ReactComponent };